export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-6">
            关于99视频
          </h2>
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="w-16 h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-5">
              <i className="ri-vidicon-line text-primary-500 text-2xl"></i>
            </div>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              99视频成立于2024年，是一个致力于聚合全网热门视频资源的综合性在线观看平台。我们汇聚了<strong>香蕉视频</strong>、<strong>红桃视频</strong>、<strong>91视频</strong>、<strong>蜜桃视频</strong>等主流视频平台的海量内容，为用户提供一站式的免费高清在线观看服务。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              平台涵盖电影、电视剧、综艺节目、动漫番剧等多个内容品类，每日同步各大平台最新上线资源，确保用户不错过任何精彩内容。我们的播放技术团队持续优化视频传输方案，实现流畅不缓冲的高清播放体验。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              无需注册、无需付费，打开即看——这是99视频始终坚持的服务理念。我们希望通过技术的力量，让每一位影迷都能轻松享受高品质的影视娱乐内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}